import { Command } from '../../_base/actionBus/Command';

export class DontSuggestPasswordReset extends Command { }
